import { render, staticRenderFns } from "./all-coures.vue?vue&type=template&id=f167f746&"
import script from "./all-coures.vue?vue&type=script&lang=js&"
export * from "./all-coures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports